import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  TDistributorSpecialPrice,
  TDistributorSpecialPriceForm,
} from "../types/distributorSpecialPrice.types";
import distributorSpecialPriceApi from "../services/distributorSpecialPrice.api";
import { useIsAuth } from "../../../utils/useAuth";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR,
  DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_SUCCESS,
} from "../constants/messages";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";

export const useSaveDistributorSpecialPriceMutation = () => {
  const queryClient = useQueryClient();
  const { userData } = useIsAuth();

  return useMutation<
    ApiResponse<TDistributorSpecialPrice>,
    Error,
    TDistributorSpecialPriceForm
  >({
    mutationFn: async (distributorSpecialPrice) => {
      const distributorSpecialPriceWithUser: TDistributorSpecialPriceForm = {
        ...distributorSpecialPrice,
        updatedBy:
          distributorSpecialPrice._id && userData?.userId
            ? userData.userId
            : undefined,
      };
      return distributorSpecialPriceApi.saveDistributorSpecialPrice(
        distributorSpecialPriceWithUser,
      );
    },
    onSuccess: (res, distributorSpecialPrice) => {
      if (!res.ok) {
        errorNotification(DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(
        DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_SUCCESS.SAVE_SUCCESS,
      );
      queryClient.invalidateQueries({
        queryKey: ["distributor-special-prices"],
      });
      if (distributorSpecialPrice._id) {
        queryClient.invalidateQueries({
          queryKey: ["distributor-special-prices", distributorSpecialPrice._id],
        });
      }
    },
    onError: (error: Error) => {
      errorNotification(DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
